"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let WContactModal = class WContactModal extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    parent;
    onParent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent");
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resource;
    async $$load_resource() {
        return this.item || this.$fn.schemaDefaults('CreateContactPerson');
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    createTitle;
    editTitle;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['resource', 'editor', 'createTitle', 'editTitle', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resource: null,
                editor: null,
                createTitle: this.$fn.pgettext("Contactes", "Add contact"),
                editTitle: this.$fn.pgettext("Contactes", "Edit contact"),
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.item == null ? this.createTitle : this.editTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_8296_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_8302_getActionArgs($event) {
        return {
            result: {
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_closeComponent_8304_getActionArgs($event) {
        return {
            result: {},
        };
    }
    async act_1040167445267876_rest_8300_getActionArgs($event) {
        return {
            method: "save",
            container: this.parent.contacts,
            resource: this.editor,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_8296 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_8296_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_8295 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_8296,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_8295],
        });
        const act_2248226175642056_closeComponent_8298 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_8297 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_8298,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_8297],
        });
        const act_1040167445267876_closeComponent_8302 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_8302_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_8301 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_8302,
            event: "saved",
            displayName: "closeComponent",
        });
        const act_1040167445267876_closeComponent_8304 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_8304_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_deleted_8303 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_8304,
            event: "deleted",
            displayName: "closeComponent",
        });
        const act_1040167445267876_rest_8300 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_8300_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_saved_8301, evh_1040167445267876_deleted_8303],
        });
        const evh_1040167445267876_submit_8299 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_8300,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_8299],
        });
        const act_1419464017721962_closeComponent_8306 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_8305 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_8306,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_8305],
        });
        return {
            act_7315092382398562_closeModal_8296,
            evh_7315092382398562_close_8295,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_8298,
            evh_2248226175642056_close_8297,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_8302,
            evh_1040167445267876_saved_8301,
            act_1040167445267876_closeComponent_8304,
            evh_1040167445267876_deleted_8303,
            act_1040167445267876_rest_8300,
            evh_1040167445267876_submit_8299,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_8306,
            evh_1419464017721962_clickPreventStop_8305,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_rest_8300,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], WContactModal.prototype, "parent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WContactModal.prototype, "onParent", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], WContactModal.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WContactModal.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], WContactModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WContactModal.prototype, "onSize", null);
WContactModal = __decorate([
    (0, vue_property_decorator_1.Component)()
], WContactModal);
exports.default = WContactModal;
vue_property_decorator_1.Vue.component("WContactModal", WContactModal);
